import { forwardRef, useState } from 'react';
import type { TextareaProps } from '@chakra-ui/react';
import { Box, Flex, Text, Textarea } from '@chakra-ui/react';

interface Props extends TextareaProps {
  maxCharacters?: number;
}

export const TextArea = forwardRef<HTMLTextAreaElement, Props>(
  ({ maxCharacters = Infinity, ...rest }, ref) => {
    const [value, setValue] = useState(rest.value);

    return (
      <Flex flexDir='column' alignItems='flex-end'>
        <Textarea
          {...rest}
          ref={ref}
          value={value}
          onChange={(e) => {
            if (e.target.value.length <= maxCharacters) {
              setValue(e.target.value);
              rest.onChange?.(e);
            }
          }}
        />
        <Box as={Text} variant='smallSemibold' color='neutral400'>
          {`${(value?.toString() ?? '').length}/${maxCharacters}`}
        </Box>
      </Flex>
    );
  },
);
